<template>
  <div class="content" v-loadmore="loadMore">
    <!-- <card-txk :data="list"></card-txk> -->
    <div>
      <card-course v-for="item in list" :key="item.id" :data="item"></card-course>
    </div>
    <loading :more="more" :loaded="loaded"></loading>
  </div>
</template>
<script type="text/ecmascript-6">
// import CardTxk from './card-txk.vue'
import CardCourse from '../card/card-course'
import Loading from '../base/loading/loading2'
import {RES_OK, PAGE_SIZE} from '@/api/config'
import {getJpList} from '@/api/jp.js'
export default {
  data() {
    return {
      loaded: false,
      more: true,
      list: [],
      page: 1
    }
  },
  components: {
    // CardTxk,
    CardCourse,
    Loading
  },
  mounted() {
    this._getFfjpList()
  },
  methods: {
    loadMore() {
      if (this.more && this.loaded) {
        this.loaded = false
        this._getFfjpList()
      }
    },
    _getFfjpList() {
      getJpList(this.page, PAGE_SIZE, '', 2, 1).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            let pageSize = 0
            data.data.forEach((item, index) => {
              if (item.data.length) {
                pageSize += item.data.length
                this.list.push(...item.data)
              }
            })
            this.loaded = true
            this.page++
            // 加载完毕
            this.more = pageSize >= PAGE_SIZE
          }
        }
      })
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    // padding-top: size(90 + 72 + 30*2)
    padding-bottom size(60)
    padding-left: size(30)
    padding-right: size(30)
  .wrap
    padding size(30)
  .no-record
    font-size size(28)
    text-align center
    color #999
    padding size(60)
</style>



// WEBPACK FOOTER //
// src/components/jpff/jpff-txk.vue